<template>
  <div class="  section_sectionWrapper">
    <div class="module-home">
      <video class="home_video__jx2_E" loop muted autoplay playsinline="">
        <source src="https://resource-mp4.ujoygames.com/ashechoes/bg_20241105.mp4" type="video/mp4">
      </video>
      <!-- 内容区域 -->
      <div class="kv-top">
        <div class="kv-title"></div>
        <div class="kv-playbtn" @click="handleVideoFlag"></div>
        <div class="kv-cnt">
          <div class="kv-time"></div>
          <div class="btn-share">
            <img src="../../assets/img/home/button-ios.png" alt="" srcset="" @click="handleIOS('ios')">
            <img src="../../assets/img/home/button-google.png" alt="" srcset="" @click="handleGG('gg')">
            <img src="../../assets/img/home/button-windows.png" alt="" srcset="" @click="handleWindows()">
            <img src="../../assets/img/home/button-stm.png" alt="" srcset="" @click="handleStm('stm')">
          </div>
        </div>
      </div>


      <!-- icon -->

      <div class="share-icon testenter">

        <div class="s-icon-2">
          <div class="icon-size ds">
            <img src="../../assets/img/home/ds.png" alt="" srcset="" @click="handleDs('ds')">
          </div>
          <div class="icon-size youtube" @click="handleYoutube('yt')">
            <img src="../../assets/img/home/youtube.png" alt="" srcset="">
          </div>

        </div>
        <div class="s-icon-3">
          <div class="icon-size twi" @click="handleTwi('twi')">
            <img src="../../assets/img/home/twi.png" alt="" srcset="">
          </div>
          <div class="icon-size Instagram" @click="handleInstagram('instagram')">
            <img src="../../assets/img/home/Instagram.png" alt="" srcset="">
          </div>
          <div class="icon-size tiktok" @click="handleTiktok('tiktok')">
            <img src="../../assets/img/home/tiktok.png" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>


    <!-- err -->
    <div class="err-model model" v-if="errModel">
      <div class="err-detail">
        <img :src="require('../../assets/img/home/regCode-' + regCode + '.png')" alt="" srcset="">
        <div class="err-close" @click="handleErrClose"></div>
      </div>
    </div>


    <!-- 视频播放
    <div v-if="videoFlag" class="model position-fixed" @click="videoFlag = false">
      <div class="v-txt">
        <iframe  width="100%" height="100%" src="https://www.youtube.com/embed/GwRmn_3z1DE?si=k53COcVrrCVCKRcZ"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'app',

  data() {
    return {
      emailPlaceholder: "メールアドレスを入力してください",
      account: "", // 账号
      regCode: -1,
      policy: true,
      errModel: false,

    }
  },
  watch: {

  },
  methods: {
    handleVideoFlag() {
      this.$emit('handleShowVideo', 0)
    },
    handlePolicy() {
      this.policy = !this.policy
    },
    handleErrClose() {
      this.errModel = false
      this.regCode = -1
    },
    handleWindows() {
      window.open(`https://ashechoes-cdn.ujoygames.jp/jp/file/_inst/b4665b3a92f29a95ab5859708d124d58/seed_setup_ja_pro_1.5.8.exe`, '_blank');
    },
    handleIOS(val) {
      this.common.goShare(val);

    },
    handleGG(val) {
      this.common.goShare(val);

    },
    handleStm(val) {
      this.common.goShare(val);

    },
    handleDs(val) {
      this.common.goShare(val);
    },
    handleYoutube(val) {
      this.common.goShare(val);
    },
    handleTwi(val) {
      this.common.goShare(val);
    },
    handleInstagram(val) {
      this.common.goShare(val);
    },
    handleTiktok(val) {
      this.common.goShare(val);
    },
    // 预注册接口
    AE_Mail_reg() {

      const reg = new RegExp(
        /^[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      );


      if (this.account === "" || !reg.test(this.account)) {
        this.regCode = 1
        setTimeout(this.errModel = true, 500)
        // return
      } else if (!this.policy) {
        this.regCode = 3
        setTimeout(this.errModel = true, 500)
        // return
      } else {
        //   邮箱输入正确后，调API
        const reqTime = Math.floor(new Date().getTime() / 1000);
        let source = this.common.getUrlParam("source") || "unknow";
        let target = this.common.getUrlParam("target") || "unknow";

        // 计算signature
        const params = {
          account: this.account,
          game: "211",
          type: 1,
        };
        this.$axios({
          method: "post",
          url: "ashechoes/subscribe",
          data: {
            account: this.account,
            game: "211",
            type: 1,
            signature: this.common.makeSignature(params, reqTime),
            reqTime: reqTime,
            source: source,
            target: target,
          },
          //withCredentials:true, //局部携带cookie
          headers: {}, //如果需要添加请求头可在这写
        })
          .then((res) => {

            if (res.data.code === 0) {
              this.regCode = 0
              this.account = ''
              gtag('event', '邮箱预约按钮点击');


            } else {
              this.regCode = 2
            }

            setTimeout(this.errModel = true, 500)
          })
          .catch((err) => { });
      }


    },


  }
}
</script>
<style lang="scss" scoped>
.module-home {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../assets/img/home_bg.png");
  z-index: 2;

  // position: absolute;
  // top: 50%;
  // left: 50%;
  width: 100%;
  height: 100%;
  // transform: translate(-50%, -50%);


  .share-icon {
    position: absolute;
    bottom: 34px;
    right: 34px;
    z-index: 1;
    display: flex;
    align-items: end;
    gap: 16px;

    img {
      width: 100%;
      height: 100%;
    }



    .icon-size {
      width: 36px;
      height: 36px;
      margin-bottom: 4px;
      cursor: pointer;
    }

  }





  .home_video__jx2_E {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .kv-top {

    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .kv-title {
    width: 1046px;
    height: 232px;
    background-size: 100% 100%;
    background-image: url("../../assets/img/home/slogan.png");
    // z-index: 1;
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translate(-50%, 0);
  }


  .kv-playbtn {
    width: 127px;
    height: 135px;
    background-size: 100% 100%;
    background-image: url("../../assets/img/home/play.png");
    z-index: 1;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }

  .kv-cnt {
    position: absolute;
    bottom: 6vw;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    .kv-time {
      width: 750px;
      height: 122px;
      background-size: 100% 100%;
      background-image: url("../../assets/img/home/kv-time.png");
    }

    .btn-share {
      margin-top: 16px;
      display: flex;
      align-items: center;
      gap: 16px;
      justify-content: center;
      cursor: pointer;

      img {
        width: 204px;
        height: 60px;
        display: inline-block;
      }
    }

    .mail {
      justify-content: center;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .m-lf {
      .title {
        width: 128px;
        height: 40px;
        background-size: 100% 100%;
        background-image: url("../../assets/img/home/login-title.png");
      }

      .input-bg {
        width: 479px;
        height: 94px;
        background-size: 100% 100%;
        background-image: url("../../assets/img/home/input-bg.png");
        position: relative;

        .inpuy-style {
          width: 383px;
          height: 43px;
          background-color: #f8fbff;
          position: absolute;
          top: 22px;
          left: 115px;
        }

        input[type="text"] {
          display: inline-block;
          font-size: 14px;
          font-family: KozMinStd-Bold;
          font-weight: bold;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #899aab;
          background: transparent;
          width: 275px;
          height: 54px;
          text-align: center;
          padding: 0 4px;
        }

        input::placeholder {
          color: #899aab;
        }
      }

      .pr {
        position: relative;
        margin-top: 12px;
        margin-left: 64px;
        display: flex;
        align-items: center;

        .c-img {
          width: 23px;
          height: 23px;
          background-image: url("../../assets/img/home/c.png");
          background-size: 100% 100%;
        }

        .c-active-img {
          width: 28px;
          height: 23px;
          background-image: url("../../assets/img/home/c-active.png");
          background-size: 100% 100%;
        }

        .c-text {
          background-image: url("../../assets/img/home/pr.png");
          background-size: 100% 100%;
          width: 251px;
          height: 20px;
          margin-left: 8px;
        }
      }
    }

    .m-reg {
      width: 103px;
      height: 143px;
      background-size: 100% 100%;
      background-image: url("../../assets/img/home/btn.png");
      margin-left: -72px;
      z-index: 1;

    }
  }

}

.err-model {
  position: fixed;

  .err-detail {
    width: 678px;
    height: 372px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    img {
      width: 100%;
      height: 100%;
    }

    .err-close {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .kv-top {
    top: 11% !important;
  }

  .kv-title {
    width: 744px !important;
    height: 162px !important;

  }

  .kv-time {
    width: 409px !important;
    ;
    height: 72px !important;
    ;

  }

  .kv-playbtn {
    width: 101px !important;
    ;
    height: 108px !important;
    ;

  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/home.vue